﻿import { h } from './element.mjs'; 
import svgIcon from '../icons.mjs';
import { Annotations } from '../core/annotations.mjs';
import { FormInput, Combobox, Checkbox, Button, ToggleButtonGroup, ToggleButton } from './formElement.mjs'; 



export default class FormulaEditor {
    constructor(outerWrap, onChange = () => { }, loc, data) {
        this.outerWrap = outerWrap;
        this.onFormulaChange = onChange;
        this.data = data;
        this.main = null;
        this.selectedTask = null;
        this.loc = loc;
        this.pageFields = null;
        this.fields = new Annotations();
        this.target = new Annotations();
        this.selectedFormula = -1;
        const handleUpdate = () => { 
            const formulaKey = this.formulaType.getValue();
            const formulaValue = this.fieldInput.getValue();
            const targetValue = this.targetInput.getValue();

            if (!formulaValue.trim()) {
                alert("Formula cannot be empty.");
                return;
            }
            if (this.selectedFormula < 0) {
                const f = data?.add({
                    key: formulaKey,
                    formula: formulaValue,
                    target: targetValue,
                });
                if (!f) return;
                this.target.each(it => it.formula = JSON.stringify(f.getData()));
            } else {
                const f = data.getNode(this.selectedFormula);
                f.key = formulaKey;
                f.formula = formulaValue;
                f.target = targetValue;
                f.source = f.getCodes(formulaValue);
                f.result = f.getCodes(targetValue);

                this.target.each(it => it.formula = JSON.stringify(f.getData()));
            }
            this._renderFormulaList(); 
            this.clear();
        };
        const deleteFormula = (key = null) => {
            if (!this.data) return;

            const indicesToRemove = new Set();

            this.target.each(it => {
                if (it.code && it.formula) {

                    const index = this.data._.findIndex(f => f.result.includes(it.code));
                    if (index === -1) return; 

                    indicesToRemove.add(index);

                    it.formula='';
                }
            });
             
            Array.from(indicesToRemove)
                .sort((a, b) => b - a)
                .forEach(index => this.data.removeAt(index));


            this._renderFormulaList(); 
            this.clear();
            
        }
        this.handleUpdate = handleUpdate;
        this.deleteFormula = deleteFormula;
        const formulaOptions = loc.formulaOperators || [
            'sum', 'average', 'max', 'min', 'custom', //'if', 'and', 'or', 'concat', 
        ];
        this.formulaType = new Combobox('formula', 'Formula', '', formulaOptions,
            (val) => { 
            if (val === 'custom') {
                this.operatorRow.show();
            } else {
                this.operatorRow.hide();
            }
        });
        this.operatorRow = this._buildOperatorRow(['+', '-', '*', '/', '(', ')']);
        this.operatorRow.hide();
        this.fieldInput = new FormulaInput(this.pageFields, 'Add Fields and Operator...', (key) => {
            const f = this.fields.getByCode(key);
            if (f?.wrapper) f.wrapper.classList.remove('formula-field');
            this.fields.removeByKey(key); 
        });
        this.targetInput = new FormulaInput(this.pageFields, 'Add Targets...', (key) => {
            const f = this.fields.getByCode(key);
            if (f?.wrapper) f.wrapper.classList.remove('formula-target');
            this.target.removeByKey(key);
        });

        this.fieldsSelect = new Checkbox('', 'Fields', false, (e) => {
            const v = e.target.checked;
            if (v) {
                this.selectTask('fieldselect');
                this.targetFieldsSelect.setValue(false);
                this.fieldInput.enable();
            } else {
                this.selectedTask = null;
                this.fieldInput.disable();
            }
        });

        this.targetFieldsSelect = new Checkbox('', 'Target Fields', false, (e) => {
            const v = e.target.checked;
            if (v) {
                this.selectTask('targetfieldselect');
                this.fieldsSelect.setValue(false);
                this.targetInput.enable();
            } else {
                this.selectedTask = null;
                this.targetInput.disable();
            }
        });
        this.formulaListDiv = h('div', 'formula-list-container d-flex flex-column gap-1'); 
        
        this.btnDiv = h('div', 'd-flex align-items-center justify-content-between gap-2 py-2'); 
        const updateBtn = new Button(this.loc.t('buttons.update'), 'k-button k-button-solid k-rounded-md k-button-md k-button-solid-light');
        const deleteBtn = new Button(this.loc.t('buttons.remove'), 'k-button k-button-solid k-rounded-md k-button-md k-button-outline-base'); 

        updateBtn.on('click', this.handleUpdate);

        deleteBtn.on('click', this.deleteFormula);
        this.btnDiv.children(deleteBtn.el, updateBtn.el);

        this.editor = h('div', 'd-flex flex-column gap-2 editor-container ').children(
            this.formulaType.el,
            this.operatorRow.el,
            this._buildFieldSection('Fields', this.fieldsSelect, this.fieldInput),
            this._buildFieldSection('Target Fields', this.targetFieldsSelect, this.targetInput),
            this.btnDiv.el,
            this.formulaListDiv.el,
        );

        outerWrap.appendChild(this.editor.el);
    }

    _buildFieldSection(labelText, toggleButton, inputComponent) {
        return h('div', 'd-flex flex-column gap-1 py-2').children(
            toggleButton.el, 
            inputComponent.el
        );
    }
    _buildOperatorRow(operators) {
        const row = h('div', 'd-flex gap-1 flex-wrap operator-buttons');
        operators.forEach(op => {
            const btn = h('button', 'btn btn-sm btn-outline-secondary').child(op);
            btn.on('click', () => this._insertOperator(op));
            row.child(btn);
        });
        return row;
    }
    _insertOperator(op) { 
        if (!'()'.includes(op)) {
            const { before, after } = this.fieldInput.getSelNonSpaceChar();
            if ('+-*/'.includes(before) || '+-*/'.includes(after)) return; 
        }
        this.fieldInput.insertOperator(op);
    }
    _renderFormulaList() {
        this.formulaListDiv.empty();
        this.selectedFormula = -1;
        const list = this.data?._ || [];
        if (!list.length) {
            this.formulaListDiv.child(h('div', 'text-muted').child('No formulas added.'));
            return;
        }

        list.forEach((f, index) => {
            const row = h('div', 'd-flex justify-content-between align-items-center formula-row border p-1 rounded bg-light')
                .attr({ 'data-index': index });

            const fields = this.pageFields?.getByCodes?.(f.result); 

            const label = h('span').child(`${f.key}: ${fields.map(field => field.name).join(', ') }`);
            const btnEdit = h('button', 'btn btn-sm btn-outline-primary').child('Edit');
            btnEdit.on('click', () => this._loadFormula(f,index));

            const btnDelete = h('button', 'btn btn-sm btn-outline-danger').child('Remove');
            btnDelete.on('click', () => {
                const confirmed = true; //confirm(`Are you sure you want to remove formula "${key}"?`);
                if (confirmed) {
                    this.remove(index, fields); 
                    this._renderFormulaList(); 
                }
            });

            const btnGroup = h('div', 'd-flex gap-2').children(btnEdit, btnDelete);

            row.children(label, btnGroup);
            this.formulaListDiv.child(row);
        });
    }
    _loadFormula(f, i) {
        this.clear();

        this.formulaType.setValue(f.key);
        this.fieldInput.setValue(f.formula || '');
        this.targetInput.setValue(f.target || '');
        this.selectedFormula = i;
        this.fields.empty();
        this.target.empty();

        const list = this.data?._ || []; 

        f.source?.forEach(code => {
            const field = this.pageFields?.getByCode?.(code); 
            if (field) {
                this.fields.push(field);
                if (field?.wrapper) field.wrapper.classList.add('formula-field');
            }
        });

        f.result?.forEach(code => {
            const field = this.pageFields?.getByCode?.(code);
            if (field) {
                this.target.push(field);
                if (field?.wrapper) field.wrapper.classList.add('formula-target');
            }
        });
    }
    remove(index, fields) {
        if (index >= 0 && index < this.data.length) {
            this.data.removeAt(index);
              
            for (const it of fields) {
                if (it.code && it.formula) {
                    it.formula = '';
                }
            }

            this._renderFormulaList();
        }
    }

    selectTask(task) {
        this.selectedTask = task;
        if (this.main) {
            this.main.selectedTask = task;
            if (this.selectedTask === 'targetfieldselect') {
                this.targetInput.setCaretTo();
            } else if (this.selectedTask === 'fieldselect') {
                this.fieldInput.setCaretTo();
            }
        }
    }

    insertField(field) {
        if (!field) return;
        if (this.selectedTask === 'targetfieldselect') { 
            this.targetInput.insertField(field);
            this.target.push(field);

        } else if (this.selectedTask === 'fieldselect') { 
            this.fields.push(field);
            this.fieldInput.insertField(field);
            
        } 
    }

    setData(main) {
        this.main = main;
        const fields = this.main.pages?.map(it => it.data?.fields); 

        const merged = new Annotations();
         
        fields?.forEach(annots => {
            if (annots && annots.length>0) {
                annots.each(a => merged.push(a));
            } 
            else if (Array.isArray(annots)) {
                annots.forEach(a => merged.push(a));
            }
        });

        this.pageFields = merged; 
        this.fieldInput.fieldList = this.pageFields;
        this.targetInput.fieldList = this.pageFields;
        this._renderFormulaList();
    }
    clear() {
        this.pageFields?.each(f => f.wrapper?.classList.remove('formula-field'));
        this.pageFields?.each(t => t.wrapper?.classList.remove('formula-target'));

        this.fields.empty();
        this.target.empty();

        this.fieldInput.setValue('');
        this.targetInput.setValue('');

        this.formulaType.setValue('');

        this.fieldsSelect.setValue(false);
        this.targetFieldsSelect.setValue(false);

    }
    hide() { 

        this.clear();
         
        this.operatorRow.hide();
        this.pageFields = null;
        this.selectedTask = null;
        if (this.main) this.main.selectedTask = null;
        this.main = null;
        this.outerWrap.classList.remove('d-flex');
        this.outerWrap.classList.add('d-none');
    }

    show() {
        this.outerWrap.classList.remove('d-none');
        this.outerWrap.classList.add('d-flex'); 
    }
}

class FormulaInput {
    constructor(fieldList = [], placeholder = 'Type formula...', onTokenRemove = () => { }) {
        this.fieldList = fieldList;
        this.onTokenRemove = onTokenRemove;
        this.wrapper = h('div', 'formula-input-wrapper position-relative');

        this.input = h('div', 'formula-input')
            .attr({
                contenteditable: 'true',
                spellcheck: 'false',
                'data-placeholder': placeholder
            });

        //this.suggestionBox = h('div', 'suggestion-box d-none');
        this.wrapper.children(this.input);// this.suggestionBox
        this._disabled = false;
        this._setupEvents();
    }
    disable() {
        this._disabled = true;
        this.input.attr("contenteditable", "false");
        this.input.addClass("disabled"); // add a class for styling
    }

    enable() {
        this._disabled = false;
        this.input.attr("contenteditable", "true");
        this.input.removeClass("disabled");
    }

    isDisabled() {
        return this._disabled;
    }
    _setupEvents() {
        //this.input.on('input', () => this._handleInput());
        this.input.on('keydown', (e) => this._handleKeyDown(e));
        //this.input.on('click', () => this._handleInput());

        //document.addEventListener('click', (e) => {
        //    if (!this.wrapper.contains(e.target)) this._hideSuggestions();
        //});
    }

    _handleInput() {
        const keyword = this._getLastWord();
        if (keyword.length === 0) return this._hideSuggestions();

        const suggestions = this.fieldList.filter(f => f.key.includes(keyword));
        suggestions.length ? this._showSuggestions(suggestions) : this._hideSuggestions();
    }

    _handleKeyDown(e) {
        if (e.key === 'Enter' && !this.suggestionBox.hasClass('d-none')) {
            e.preventDefault();
            const firstItem = this.suggestionBox.el.querySelector('.suggestion-item');
            if (firstItem) firstItem.click();
        }
        const sel = window.getSelection();
        if (!sel.rangeCount) return;
        const range = sel.getRangeAt(0);
        const { startContainer, startOffset } = range;

        let targetNode = null;
         
        if (e.key === 'Backspace' && startOffset === 0) {
            targetNode = startContainer.previousSibling;
        }
        else if (e.key === 'Backspace' && startOffset > 0 && startContainer?.nodeType != 3) {
            const n = startContainer.childNodes[startOffset - 1];
            if (n?.classList?.contains('formula-token')) {
                targetNode = n;
            }
            if (n?.nodeType == 3 && n.previousSibling?.nodeType == 1) {
                targetNode = n.previousSibling;
            }
        } 
        else if(e.key === 'Delete' && startOffset === startContainer.length) {
            targetNode = startContainer.nextSibling;
        }
         
        if (!targetNode && sel.anchorNode?.nodeType === 1 && sel.anchorNode.classList.contains('formula-token')) {
            targetNode = sel.anchorNode;
        }
         
        if (targetNode?.classList?.contains('formula-token')) {
            e.preventDefault();
            const key = targetNode.getAttribute('data-key');
            if (key) this.onTokenRemove(key);
            targetNode.remove();
            return;
        }
    }

    _getLastWord() {
        const sel = window.getSelection();
        if (!sel.rangeCount) return '';
        const text = sel.getRangeAt(0).startContainer.textContent || '';
        return text.trim().split(/\s+/).pop() || '';
    }

    _showSuggestions(matches) {
        this.suggestionBox.empty().removeClass('d-none');
        matches.forEach(f => {
            const item = h('div', 'suggestion-item').html(f.label);
            item.on('click', () => {
                this._insertToken(f);
                this._hideSuggestions();
            });
            this.suggestionBox.child(item);
        });
    }
    getSelNonSpaceChar() {
        const sel = window.getSelection();
        if (!sel.rangeCount) return { before: null, after: null };

        const range = sel.getRangeAt(0);
        const container = range.startContainer;
        const offset = range.startOffset;

        let before = null;
        let after = null;

        // Check if container is a text node
        if (container.nodeType === 3) {
            const text = container.textContent;

            // Get character before caret
            for (let i = offset - 1; i >= 0; i--) {
                if (text[i] !== ' ') {
                    before = text[i];
                    break;
                }
            }

            // Get character after caret
            for (let i = offset; i < text.length; i++) {
                if (text[i] !== ' ') {
                    after = text[i];
                    break;
                }
            }
        }

        return { before, after };
    }
    getLastNonSpaceChar() {
        const content = this.input.el.textContent || '';
        const trimmed = content.trim();
        if (trimmed.length === 0) return '';
        return trimmed[trimmed.length - 1];
    }
    insertOperator(op) {
        this._insertText(` ${op} `);
        this.setCaretTo(); 
    }
     
    _insertText(text) {
        this._insertNode(document.createTextNode(text));
    }

    _insertNode(node) {
        const sel = window.getSelection();
        if (!sel.rangeCount || sel.focusNode.className != 'formula-input' && sel.focusNode.parentNode.className != 'formula-input' ) return;
        const range = sel.getRangeAt(0);
        range.deleteContents();
        range.insertNode(node);
        range.collapse(false);
        sel.removeAllRanges();
        sel.addRange(range);
        this.input.focus();
    }
    setCaretAfterNode(node) { 
        const range = document.createRange();
        const sel = window.getSelection();
        range.setStartAfter(node);
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);
    }
    setCaretTo() {
        const range = document.createRange();
        const sel = window.getSelection();
        range.selectNodeContents(this.input.el);
        range.collapse(false); // true = start
        sel.removeAllRanges();
        sel.addRange(range);
        this.input.focus();
    }

    _hideSuggestions() {
        this.suggestionBox.addClass('d-none').empty();
    }

    insertField(field) {
        const token = h('span', 'formula-token')
            .attr({ 'data-key': field.code, contenteditable: 'false' })
            .html(field.name);
        this._insertNode(token.el);
        //this._insertText(' ');
    }

    setValue(formulaStr) {
        this.input.empty();
        this.input.focus();
        const tokens = formulaStr.split(/(\[[^\]]+\])/);
        tokens.forEach(t => {
            if (t.startsWith('[') && t.endsWith(']')) {
                const key = t.slice(1, -1);
                const match = this.fieldList.getByCode(key);
                match ? this.insertField(match) : this._insertText(t);
            } else {
                this._insertText(t);
            }
        });
    }

    getValue() {
        return Array.from(this.input.el.childNodes).map(node => {
            return node.classList?.contains('formula-token') ? `[${node.dataset.key}]` : node.textContent;
        }).join('').replace(/\s+/g, ' ').trim();
    }

    get el() {
        return this.wrapper.el;
    }
}

//export default class MultiFieldEditor {
//    constructor(update = () => { }, setAlign = () => { }, deleteField = () => { }) {
//        this.update = update;
//        this.setAlign = setAlign;
//        this.deleteField = deleteField;
//        this.annotts = null;
//        const handleUpdate = (key = null) => {
//            if (!this.annotts) return;
//            const { fieldTarget, fieldFormula } = this;
             
//            this.update(fieldTarget.getValue(), fieldFormula.getValue());
//        }
//        const handleHAlign = () => {
//            const { hAlign } = this;
//            this.setAlign(hAlign.getValue(), false);
//        }
//        const handleVAlign = () => {
//            const {  vAlign } = this;
//            this.setAlign(false, vAlign.getValue());
//        }
//        this.handleHAlign = handleHAlign;
//        this.handleVAlign = handleVAlign;
//        this.handleUpdate = handleUpdate;
//        this.outerWrap = document.getElementById('editContainer');
//        this.editor = h('div', 'd-flex flex-column gap-2 editor-container');
//        this.header = h('div', 'd-flex gap-2 align-items-center');
//        this.fieldSet = h('div','d-flex flex-column gap-1 field-set'); 
//        this.editorWrap = h('div', 'd-flex flex-column gap-2 flex-fill overflowy-scroll');  
//        this.fieldWidth = new FormInput('fieldWidth', 'Width', 'number', this.handleUpdate);
//        this.fieldHeight = new FormInput('fieldHeight', 'Height', 'number', this.handleUpdate); 
//        this.fieldFormula = new Combobox('formula', 'Formula', '', ['SUM', 'AVERAGE', 'MAX', 'MIN', 'IF', 'AND', 'OR', 'CONCAT'], this.formulaChange ); 
//        this.fieldTarget = new Combobox('target', 'Formula', '', [], this.targetChange); 
//        this.hAlign = new ToggleButtonGroup('Horizontal Align', [
//            { label: 'Left', value: 'left', icon: svgIcon.alignLeft },
//            { label: 'Center', value: 'center', icon: svgIcon.alignCenter },
//            { label: 'Right', value: 'right', icon: svgIcon.alignRight }
//        ], null, false, this.handleHAlign);

//        this.vAlign = new ToggleButtonGroup('Vertical Align', [
//            { label: 'Top', value: 'top', icon: svgIcon.alignTop },
//            { label: 'Middle', value: 'middle', icon: svgIcon.alignMiddle },
//            { label: 'Bottom', value: 'bottom', icon: svgIcon.alignBottom }
//        ], null, true, this.handleVAlign);  
//        this.sameHeight = new ToggleButton('Same Height', svgIcon.height, false, (val) => {
//            console.log('Toggled:', val);
//        });
//        this.sameWidth = new ToggleButton('Same Width', svgIcon.width, false, (val) => {
//            console.log('Toggled:', val);
//        });
//        this.formulaChange = (e) => { };
//        this.targetChange = (e) => { };
//        this.renderSkeleton();
//        this.renderInputs();
//        this.renderButtons(); 
//    } 
//    ratioClick(e) {

//    } 
//    renderSkeleton() {
//        this.outerWrap.appendChild(this.editor.el);
//        const closeBtn = new Button('Close', 'k-button k-button-solid k-rounded-md k-button-md k-button-flat-base');
//        closeBtn.on('click', () => { this.hide(); });
//        this.header.children(
//            h('h6', 'flex-fill').child('Multiple Fields'),
//            closeBtn.el
//        );
//        this.editor.child(this.header);

//    } 
//    renderInputs() {
//        this.editorWrap
//            .children(
//                this.fieldSet.el,
//                h('div', 'd-flex gap-2').children(this.fieldFormula.el, this.fieldTarget.el),
//                h('div', 'd-flex gap-3').children(this.fieldWidth.el, this.fieldHeight.el),
//                h('div', 'd-flex gap-2').children(this.hAlign.render(), this.vAlign.render()),
//                h('div', 'd-flex gap-2').children(this.sameHeight.render(), this.fieldHeight.el, this.sameWidth.render(), this.fieldWidth.el)
//            );

//        this.editor.child(this.editorWrap);
//    } 
//    renderButtons() {
//        const btnDiv = h('div', 'd-flex align-items-center justify-content-between gap-2 py-2');

//        const updateBtn = new Button('Update', 'k-button k-button-solid k-rounded-md k-button-md k-button-solid-light');
//        const deleteBtn = new Button('Remove', 'k-button k-button-solid k-rounded-md k-button-md k-button-outline-base');

//        updateBtn.on('click', () => { this.handleUpdate(); this.hide(); });
//        deleteBtn.on('click', () => { this.deleteField(); this.hide(); });

//        btnDiv.children(deleteBtn.el, updateBtn.el);
//        this.editor.child(btnDiv);
//    }

//    setData(page, update, setAlign) {
//        const { fieldSet, fieldTarget, fieldFormula, fieldWidth, fieldHeight } = this; 
//        const { data, selection } = page;
//        const annotts = selection._;
//        this.annotts = annotts;
//        this.update = update;
//        this.setAlign = setAlign;
//        fieldSet.empty();
//        if (annotts?.length > 0) {
//            fieldWidth.setValue(annots[0].width || 0);
//            fieldHeight.setValue(annots[0].height || 0);
//            annotts.forEach(a => {
//                const n = h('div', 'node');
//                const l = h('label').child(a.code);
//                const b = h('button').on('click', () => {
//                    selection.remove(a);
//                    n.hide();
//                });
//                n.children(l.el, b.el);
//                fieldSet.child(n);
//                if (fieldWidth.getValue() == a.width) fieldWidth.setValue(a.width)
//                else fieldWidth.multipleValues(true);
//                if (fieldHeight.getValue() == a.height) fieldHeight.setValue(a.height)
//                else fieldWidth.multipleValues(true);
//            });
//        }
//        const a = data.fields.getData().map(f => ({
//            key: f.code,
//            label: f.name || ''
//        }));
//        fieldTarget.populate(a).then(() => {
//            const f = data.formulas.getFormulaWith(selection.getCodes());
//            fieldTarget.setValue(f?.target);
//            fieldFormula.setValue(f?.key);
//        }); 
        
//    }
//    hide() {
//        const { fieldWidth, fieldHeight, fieldSet } = this;
//        fieldWidth.hide(); fieldHeight.hide(); 
//        this.editor.removeClass('d-flex');
//        this.editor.addClass('d-none'); 
//    } 
//    show() {
//        this.editor.addClass('d-flex');
//        this.editor.removeClass('d-none'); 
//    }
//}
